<footer class="p-4 bg-dark sm:p-6">
  <div class="mx-auto max-w-screen-xl pt-10">
    <div class="md:flex md:justify-between pb-20">
      <div class="mb-6 md:mb-0">
        <div class="flex items-center text-white">
          <img
            src="assets/icon/codijobs-icon.png"
            alt="logo"
            class="mr-2 h-10"
          />
          <span
            class="self-center text-white text-2xl font-semibold whitespace-nowrap"
            >Codijobs</span
          >
        </div>
        <p class="text-white font-light mt-3 max-w-full sm:max-w-md">
          Codijobs es una plataforma integral de búsqueda y gestión de
          oportunidades laborales, diseñada para conectar talento con empresas
          en diversos sectores y servicios.
        </p>
      </div>
      <div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
        <div>
          <h2 class="mb-6 text-sm font-semibold text-white uppercase">
            Otros proyectos
          </h2>
          <ul class="text-gray-400 dark:text-gray-400">
            <li class="mb-4">
              <a
                href="https://web.sysef.com/"
                target="_blank"
                class="hover:underline"
                >Sysef</a
              >
            </li>
            <li>
              <a
                href="https://codiservice.codideep.com/"
                target="_blank"
                class="hover:underline"
                >Codiservice</a
              >
            </li>
          </ul>
        </div>
        <div>
          <h2 class="mb-6 text-sm font-semibold text-white uppercase">
            Sobre Nosotros
          </h2>
          <ul class="text-gray-400">
            <li class="mb-4">
              <a
                href="https://wa.me/51956248003"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:underline transition break-words break-all"
              >
                +51 956 248 003
              </a>
            </li>
            <li>
              <a
                href="mailto:contact@codideep.com"
                target="_blank"
                rel="noopener noreferrer"
                class="hover:underline transition break-words break-all"
              >
                contact@codideep.com
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h2 class="mb-6 text-sm font-semibold text-white uppercase">Legal</h2>
          <ul class="text-gray-400 dark:text-gray-400">
            <li class="mb-4">
              <p>Ley de protección de datos</p>
            </li>
            <li>
              <p>Políticas de privacidad</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto lg:my-8" />
    <div class="sm:flex sm:items-center sm:justify-between">
      <span class="text-sm text-gray-100 sm:text-center"
        >Copyright © 2025 - 2025
        <a
          href="https://eirl.codideep.com/"
          target="_blank"
          class="hover:underline"
          >Codideep's developer</a
        >. Todo los derechos reservados.
      </span>
      <div class="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
        <a
          href="https://www.facebook.com/codideep"
          target="_blank"
          class="text-gray-500 hover:text-white dark:hover:text-white"
        >
          <ng-icon name="bootstrapFacebook" />
        </a>
        <a
          href="https://www.linkedin.com/company/codideep/"
          target="_blank"
          class="text-gray-500 hover:text-white dark:hover:text-white"
        >
          <ng-icon name="bootstrapLinkedin" />
        </a>
        <a
          href="https://www.youtube.com/@Codideep"
          target="_blank"
          class="text-gray-500 hover:text-white dark:hover:text-white"
        >
          <ng-icon name="bootstrapYoutube" />
        </a>
      </div>
    </div>
  </div>
</footer>
